import { FC } from 'react';

/**
 * 해당 부고를 찾을 수 없을 때(서버 404 / 조회 실패) 보여주는 안내.
 * 기간이 지난 부고는 차단하지 않고 개인정보 없이 계속 이용할 수 있으므로,
 * 이 화면은 "링크 자체가 유효하지 않은" 경우에만 쓰인다.
 */
export const CourtesyGateNotice: FC = function CourtesyGateNotice() {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="px-6 py-16">
        <div className="center-box flex-col gap-3 rounded-2xl bg-white px-6 py-10 text-center shadow-sm ring-1 ring-gray-100">
          <p className="text-lg font-bold text-gray-900">부고 정보를 찾을 수 없습니다</p>
          <p className="whitespace-pre-line break-keep text-sm leading-relaxed text-gray-500">
            {'링크가 만료되었거나\n주소가 정확하지 않을 수 있습니다.\n문자로 받으신 링크로 다시 접속해 주세요.'}
          </p>
        </div>
      </div>
    </div>
  );
};
